import { useState, useEffect, useRef } from 'react'
import style from './Chat.module.css'
import ChatInput from './ChatInput'
import ResponseFileIcon from './components/ResponseFileIcon'

const ChatInterface = ({
  history,
  loading,
  handleResponses,
  smallInterface,
  setOpenUpload,
  openUpload,
  errorMessage,
  setErrorMessage,
}) => {
  const [formData, setFormData] = useState({ message: '' })
  const chatContainerRef = useRef(null)

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }, [history, loading])

  return (
    <div
      className={`${style.chatInterfaceContainerBig} ${
        smallInterface && style.chatInterfaceContainer
      }`}
    >
      <div
        style={{ display: 'flex', flexDirection: 'column' }}
        className={`${style.scrollChat}`}
        ref={chatContainerRef}
      >
        {history.map((entry, index) => (
          <div key={index} className={style[entry.type]}>
            <span>{entry.content}</span>

            {entry.type === 'request' && entry.feed_metadata ? (
              <div className={style.request_metadata_container}>
                {entry.feed_metadata.map((metadata, index) => (
                  <ResponseFileIcon key={index} metadata={metadata} />
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        ))}
        {loading && <div className={`${style.responsez}`}></div>}
      </div>
      {!smallInterface && (
        <div className={style.bigInput}>
          <ChatInput
            setOpenUpload={setOpenUpload}
            openUpload={openUpload}
            handleResponses={handleResponses}
            setFormData={setFormData}
            formData={formData}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      )}
    </div>
  )
}

export default ChatInterface
